var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.823,
    height: 37.823,
    viewBox: "0 0 37.823 37.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175568",
    "data-name": "Group 175568",
    transform: "translate(-1.076 -53.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168709",
    "data-name": "Path 168709",
    d: "M18.912,0A18.912,18.912,0,1,1,0,18.912,18.912,18.912,0,0,1,18.912,0Z",
    transform: "translate(1.076 53.054)",
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cc721026ad1acb132292e35cc7d12978",
    d: "M2.56,4.739a.928.928,0,0,0,.93.93h.5V16.65a3.059,3.059,0,0,0,3.055,3.061h7.7a3.059,3.059,0,0,0,3.055-3.061V5.668h.5a.93.93,0,0,0,0-1.859H15.035V2.849A2.351,2.351,0,0,0,12.686.5H9.092A2.351,2.351,0,0,0,6.743,2.849v.961H3.49A.928.928,0,0,0,2.56,4.739Zm11.57,3.57v6.9a.93.93,0,0,1-1.859,0v-6.9a.93.93,0,1,1,1.859,0ZM8.6,2.849a.487.487,0,0,1,.49-.49h3.594a.487.487,0,0,1,.49.49v.961H8.6V2.849Zm-.954,5.46a.93.93,0,1,1,1.859,0v6.9a.93.93,0,0,1-1.859,0Z",
    transform: "translate(9.099 61.859)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.3b71d56fe4fa87e7156a0e1c87980b93.svg";
export { ForwardRef as ReactComponent };